import React, { useEffect, useState } from 'react'
import { SubjectCategryCard } from '../../../components/subects/SubjectCard'
import xhr from '../../../utils/fetch'
import { useNavigate, useParams } from 'react-router-dom'
import { LOADING } from '../../../assets/animated'
import { BACK_ARROW } from '../../../assets/icons'
import BreadCrumb from '../../../components/BreadCrumb'
import { CAUTION } from '../../../assets/images'
import Footer from '../../../components/Landing/Footer'
import { SEO } from '../../../components/SEO'

function Subjects() {
    const [subjectCat,setSubjectCat] = useState([])
    const [Category,setCategory] = useState<any[]>([])
    const [loading,setLoading] = useState(false)
    const navigate = useNavigate();
    const {id} = useParams();

    useEffect(()=>{
      xhr({
        url:`/s/getAllCategories`,
        method:"GET"
      }).then(res=>(setCategory(res.data)))
        .catch(err=>err)
  },[]) 
    
  const subjectcategory = Category.filter(item=>item?._id === id)
  
       useEffect(()=>{
        xhr({
           url:`/s/getSubjectsByCategory/${id}`,
            method:"GET"
        }).then(res=>{
            setLoading(true)
            setSubjectCat(res.data)
        })
          .catch(err=>{
            setLoading(true);
            err
          })
          
    },[])
 
  const subjectName = subjectcategory[0]?.category?.name || 'Subject';
 
  return (
    <>
    <SEO 
      title={`${subjectName} - Online Classes & Tutoring`}
      description={`Learn ${subjectName} with expert online tutors. Book personalized one-on-one classes. Interactive learning with qualified teachers.`}
      keywords={`${subjectName}, online ${subjectName} classes, ${subjectName} tutoring, learn ${subjectName}, online tutoring`}
      url={`/subjects/${id}`}
      type="website"
      og={{
        type: 'website',
        siteName: 'WorldoTutor',
        locale: 'en_US',
        image: {
          url: '/imgi_1_favicon.png',
          alt: `${subjectName} - WorldoTutor`,
          width: 1200,
          height: 630
        }
      }}
      twitter={{
        card: 'summary_large_image',
        site: '@worldotutor',
        image: {
          url: '/imgi_1_favicon.png',
          alt: `${subjectName} - WorldoTutor`
        }
      }}
    />
     <div className=''>
 
        
          <div className='container mx-auto'>
          <div className="hidden md:flex gap-3 py-5">
          <div
            className="w-8 h-8 flex items-center justify-center bg-neutralBlue2 rounded-full cursor-pointer drop-shadow-md"
            onClick={() => navigate(-1)}
          >
            <img src={BACK_ARROW} alt="Go Back" />
          </div>
          <BreadCrumb />
        </div>
          </div>
                 <div className='container md:pt-0 pt-5 '>
        <div className="md:bg-whit flex flex-col gap-4 p-5 rounded">
          <h2 className="text-5xl font-semibold capitalize">{subjectcategory?.[0]?.name}</h2>
        </div>
            {/* <LandingMain title='Explore Our Online Class by Subject' subTitle='' searchBox={false}/> */}
        </div>

         <div className='py-10 grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 container gap-y-10 gap-x-2 mx-auto'>
       { !loading ? (<div className="min-h-[512px] flex items-center justify-center">
            <img src={LOADING} className="w-14 h-14" />
          </div>):(
           <>
           {
            subjectCat.length > 0 ?( 
            subjectCat.map((item:any,indx)=>(
                
                <SubjectCategryCard name={item.name} title={"online"} key={indx} id={item._id}/>
            ))):(<>
                <div className="flex flex-col gap-5 items-center py-10">
                  <img src={CAUTION} alt="No subjects found" className="rounded-full" />
                  <div className="flex flex-col items-center w-full gap-2">
                    <span className="text-2xl font-medium">Oops,</span>
                    <span className="w-full text-lg font-normal text-center">No Subject found.</span>
                  </div>
                 
                </div>
              </>)
        }
        </>
       )
       }
    </div>
        
     </div>
     <div className="bg-neutralBlack" id="footer">
     <Footer/>
     </div>
     </>
  )
}

export default Subjects
